function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 7");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  stroke: "#FF2B67"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  fill: "#F3F0F0",
  strokeWidth: 2.07999992
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-2",
  cx: 10.7249996,
  cy: 10.7249996,
  r: 9.68499964
})), /*#__PURE__*/React.createElement("g", {
  id: "close",
  transform: "translate(7.000000, 7.000000)",
  fill: "#FF2B67",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.88110569,4 L7.87219512,1.00858592 C7.95447154,0.926239105 7.99986992,0.816378301 8,0.69923247 C8,0.582021595 7.95460163,0.472030701 7.87219512,0.389813972 L7.6100813,0.127748146 C7.5276748,0.0452061923 7.41782114,0 7.30055285,0 C7.18347967,0 7.07362602,0.0452061923 6.99121951,0.127748146 L4.00013008,3.11896709 L1.00891057,0.127748146 C0.926634146,0.0452061923 0.816715447,0 0.699512195,0 C0.582439024,0 0.472520325,0.0452061923 0.390243902,0.127748146 L0.128,0.389813972 C-0.0426666667,0.560491739 -0.0426666667,0.838103291 0.128,1.00858592 L3.11915447,4 L0.128,6.99128399 C0.0456585366,7.0737609 0.000325203252,7.1836217 0.000325203252,7.30076753 C0.000325203252,7.41791336 0.0456585366,7.52777416 0.128,7.61018603 L0.390178862,7.87225185 C0.472455285,7.95472876 0.582439024,8 0.699447154,8 C0.816650407,8 0.926569106,7.95472876 1.00884553,7.87225185 L4.00006504,4.88096787 L6.99115447,7.87225185 C7.07356098,7.95472876 7.18341463,8 7.3004878,8 L7.30061789,8 C7.4177561,8 7.52760976,7.95472876 7.61001626,7.87225185 L7.87213008,7.61018603 C7.9544065,7.52783921 7.99980488,7.41791336 7.99980488,7.30076753 C7.99980488,7.1836217 7.9544065,7.0737609 7.87213008,6.99134903 L4.88110569,4 Z",
  id: "Path"
}))));

var SvgStatusRed = function SvgStatusRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatusRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status-red.e09c55c4.svg";
export { ForwardRef as ReactComponent };